import { render, staticRenderFns } from "./ModuleTitle.vue?vue&type=template&id=c9afe70a&scoped=true&"
import script from "./ModuleTitle.vue?vue&type=script&lang=js&"
export * from "./ModuleTitle.vue?vue&type=script&lang=js&"
import style0 from "./ModuleTitle.vue?vue&type=style&index=0&id=c9afe70a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9afe70a",
  null
  
)

export default component.exports